"use client";

import { Avatar, Box, Button, DropdownMenu, Text } from "@radix-ui/themes";
import _ from "lodash";
import { useSession } from "next-auth/react";
import { useState } from "react";
import { Skeleton } from "@/components";
import SignInDialog from "@/components/SignInDialog";
import SignOutButton from "@/components/SignOutButton";
import { ChevronDownIcon } from "@/public/index";

export default function AuthStatus() {
    const { status, data: session } = useSession();
    const fallback = "?";
    const email = _.get(session, "user.email", fallback);
    const name = _.get(session, "user.name", fallback);
    const initials = name
        .split(" ")
        .map((n) => n[0])
        .join("");
    const [loginDialogOpen, setLoginDialogOpen] = useState<boolean>(false);

    if (!status || status === "loading") return <Skeleton width="3rem" />;

    if (status === "unauthenticated")
        return (
            <>
                <SignInDialog open={loginDialogOpen} setOpen={setLoginDialogOpen} />
            </>
        );

    return (
        <>
            <Box className="text-white">
                <DropdownMenu.Root>
                    <DropdownMenu.Trigger>
                        <Button data-testid="login-avatar" className="bg-white">
                            <Text as="p" className="text-black" weight="medium" size="3">
                                {name}
                            </Text>
                            <Avatar fallback={initials} radius="full" className="cursor-pointer" variant="solid" color="gray" />
                            <ChevronDownIcon />
                        </Button>
                    </DropdownMenu.Trigger>
                    <DropdownMenu.Content>
                        <DropdownMenu.Label>
                            <Text size="2" data-testid="login-creds">
                                {name} {email}
                            </Text>
                        </DropdownMenu.Label>
                        <SignOutButton data-testid="logout" text="Log out" />
                    </DropdownMenu.Content>
                </DropdownMenu.Root>
            </Box>
        </>
    );
}
